// Códigos canônicos de Tipo_Remuneracao (DW-0982 — Melhoria Valor Fixo).
// Devem espelhar Setpar.Domain/Juridico/HorasPjLabels.cs.
export const TIPO_REMUNERACAO_HORA = 'H';
export const TIPO_REMUNERACAO_FIXO = 'F';

const formatadorMoedaPtBr = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
});

export const formatarMoeda = (valor) => {
  if (valor == null || Number.isNaN(Number(valor))) return '—';
  return formatadorMoedaPtBr.format(Number(valor));
};

// "Por Hora" / "Valor Fixo" / "—" (quando vigência não existe).
export const descreverTipoRemuneracao = (tipo) => {
  if (tipo === TIPO_REMUNERACAO_HORA) return 'Por Hora';
  if (tipo === TIPO_REMUNERACAO_FIXO) return 'Valor Fixo';
  return '—';
};

// Formata a remuneração de uma vigência ou snapshot como "R$ X,XX/h" nas duas
// modalidades. Em Tipo='F', valor_hora já vem populado do banco como
// Valor_Fixo / Horas_Base (vigência) ou Valor_Fixo / Horas_Trabalhadas (snapshot)
// — ADR-013. Detalhes do contrato (valor fixo, horas base) aparecem no modal de
// edição, não nas listagens.
// Espelha HorasPjLabels.FormatarRemuneracao no backend.
export const formatarRemuneracao = (tipo, valorHora /* , valorFixo, horasBase */) => {
  if ((tipo === TIPO_REMUNERACAO_HORA || tipo === TIPO_REMUNERACAO_FIXO) && valorHora != null) {
    return `${formatarMoeda(valorHora)}/h`;
  }
  return '—';
};

// Default histórico dos percentuais de retenção (DW-0982 — Melhoria Percentuais por Contrato).
export const PERCENTUAL_RETENCAO_DEFAULT = 10;

// Formata os 3 percentuais como "10/10/10%" (atalho quando todos default) ou
// "13ª: X% / 14ª: Y% / Fundo: Z%". Aceita null/undefined → trata como 10.
export const formatarPercentuaisRetencao = (p13, p14, pFundo) => {
  const v13 = p13 != null ? Number(p13) : PERCENTUAL_RETENCAO_DEFAULT;
  const v14 = p14 != null ? Number(p14) : PERCENTUAL_RETENCAO_DEFAULT;
  const vFundo = pFundo != null ? Number(pFundo) : PERCENTUAL_RETENCAO_DEFAULT;
  if (v13 === 10 && v14 === 10 && vFundo === 10) return '10/10/10%';
  const fmt = (n) => (n % 1 === 0 ? n.toFixed(0) : n.toString().replace('.', ','));
  return `13ª: ${fmt(v13)}% / 14ª: ${fmt(v14)}% / Fundo: ${fmt(vFundo)}%`;
};

export const formatarCnpj = value => {
  const cnpj = (value || '').toString().toUpperCase().replace(/[^A-Z0-9]/g, '');
  if (cnpj.length !== 14) return value || '-';

  return `${cnpj.slice(0, 2)}.${cnpj.slice(2, 5)}.${cnpj.slice(5, 8)}/${cnpj.slice(8, 12)}-${cnpj.slice(12, 14)}`;
};

export function formatarCompetencia(competencia) {
  const regex = /^(\d{4})-(\d{2})$/;
  const match = competencia.match(regex);

  if (!match){
    return null;
  }
  
  const ano = match[1];
  const mes = match[2];

  const meses = [
    'Janeiro',
    'Fevereiro',
    'Março',
    'Abril',
    'Maio',
    'Junho',
    'Julho',
    'Agosto',
    'Setembro',
    'Outubro',
    'Novembro',
    'Dezembro'
  ];

  if (mes < 1 || mes > 12) {
    return null;
  }

  return `${meses[mes - 1]} de ${ano}`;
}